import axios from "axios";
import { IRequest, IResponse, IError, HTTPMethod } from "./Inetwork";
import store from "@/store";

export class BaseHTTPClient {
  // TODO: Provides custom config for axios

  public request<U extends IResponse>(request: IRequest): Promise<U> {
    const isGet = request.method === HTTPMethod.GET;
    return new Promise<U>((resolve, reject) => {
      axios
        .request({
          url: request.path,
          method: request.method,
          params: isGet && request.params,
          data: !isGet && request.data,
        })
        .then((data) => {
          resolve(this.transform<U>(data));
        })
        .catch((err) => {
          const apiError = this.normalizeError(err);
          reject(apiError);
        });
    });
  }

  private transform<U extends IResponse>(data: any): U {
    return data;
  }

  private normalizeError(error: any): IError {
    // Logic of error handling
    return {
      status: error.status,
      message: error.data?.message,
      raw: error,
    };
  }
}
